import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';

import { CmsServerService } from 'src/app/services/jsonrpc/cms-server.service';

import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
  selector: 'app-icon-exchange',
  templateUrl: './icon-exchange.component.html',
  styleUrls: ['./icon-exchange.component.scss']
})
export class IconExchangeComponent {
  public uploading = false;
  public iconUrl = 'public/icon.png';

  public uploadProgress = {};

  private sizes = [
    { title: 'icon.png', width: 512, height: 512 },
    { title: 'icon-512x512.png', width: 512, height: 512 },
    { title: 'icon-384x384.png', width: 384, height: 384 },
    { title: 'icon-192x192.png', width: 192, height: 192 },
    { title: 'icon-152x152.png', width: 152, height: 152 },
    { title: 'icon-144x144.png', width: 144, height: 144 },
    { title: 'icon-128x128.png', width: 128, height: 128 },
    { title: 'icon-96x96.png', width: 96, height: 96 },
    { title: 'icon-72x72.png', width: 72, height: 72 }
  ];

  public imageFormats = {
    'image/png': 'image',
    'image/jpeg': 'image'
  };

  constructor(private server: CmsServerService, private http: HttpClient) {}
  @ViewChild(FileUploadComponent) private fileUpload: FileUploadComponent;

  public uploadIcon(files: { title: string; file: File }[]) {
    this.uploading = true;

    // check whether only one file can get uploaded
    const file = files[0].file;
    const reader = new FileReader();

    this.uploading = true;

    reader.readAsDataURL(file);
    reader.onload = async () => {
      await this.resizeImage(reader.result as string).then((data: [{ title: string; data: string }]) => {
        const files_resized = data.map(d => new File([this.dataURItoBlob(d.data)], d.title));
        const promises = [];

        for (const f of files_resized) {
          promises.push(
            this.server.mediaPublicUpload({ filename: f.name }).then(
              res =>
                new Promise((resolve, reject) => {
                  this.http
                    .put(res.url, f, {
                      reportProgress: true,
                      observe: 'events'
                    })
                    .subscribe(
                      ev => {
                        if (ev.type == HttpEventType.Response) {
                          return setTimeout(() => resolve({ url: res.url, file: f }), 1500);
                        } else if (ev.type == HttpEventType.UploadProgress) {
                          this.uploadProgress[f.name] = Math.round((ev.loaded / ev.total) * 100);
                        }
                      },
                      err => reject(err)
                    );
                })
            )
          );
        }

        return Promise.all(promises).then((resolved: any) => {
          this.iconUrl = resolved[0].url.split('?')[0];
          this.cleanFileUpload();
        });
      });
    };
  }

  public cleanFileUpload() {
    this.uploadProgress = {};
    this.uploading = false;
    this.fileUpload.reset();
  }

  private resizeImage(imageURL: any): Promise<any> {
    const promises = [];

    for (const size of this.sizes) {
      promises.push(
        new Promise(resolve => {
          const image = new Image();
          image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = size.width;
            canvas.height = size.height;
            const ctx = canvas.getContext('2d');
            if (ctx != null) {
              ctx.drawImage(image, 0, 0, size.width, size.height);
            }
            const data = canvas.toDataURL('image/png', 1);
            resolve({ title: size.title, data: data });
          };
          image.src = imageURL;
        })
      );
    }
    return Promise.all(promises);
  }

  // I'm stolen from the internet, please ignore me
  private dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: mimeString });
    return blob;
  }
}
